
import {Box, Tab, Tabs, Tooltip} from '@mui/material';

const DeviceTabs = ({activeDevice, onDeviceChange, deviceTypes = ['mobile', 'tablet', 'desktop']}) => {
  const devices = {
    mobile: {id: 'mobile', label: '📱 Mobile', icon: '📱', width: '<768px'},
    tablet: {id: 'tablet', label: '💻 Tablet', icon: '💻', width: '768px-1024px'},
    desktop: {id: 'desktop', label: '🖥️ Desktop', icon: '🖥️', width: '>1024px'},
  };

  const filteredDevices = deviceTypes.map(type => devices[type]);

  return (
    <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
      <Tabs
        value={activeDevice}
        onChange={(e, v) => onDeviceChange(v)}
        variant="fullWidth">
        {filteredDevices.map(device => (
          <Tab
            key={device.id}
            value={device.id}
            label={
              <Tooltip title={device.width} placement="top">
                <Box display="flex" alignItems="center" gap={1}>
                  <span>{device.label}</span>
                </Box>
              </Tooltip>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default DeviceTabs;

// const DeviceTabs = ({activeDevice, onDeviceChange}) => {
//   const devices = [
//     {id: 'mobile', label: '📱 Mobile', icon: '📱', width: '<768px'},
//     {id: 'tablet', label: '💻 Tablet', icon: '💻', width: '768px-1024px'},
//     {id: 'desktop', label: '🖥️ Desktop', icon: '🖥️', width: '>1024px'},
//   ];

//   return (
//     <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
//       <Tabs
//         value={activeDevice}
//         onChange={(e, v) => onDeviceChange(v)}
//         variant="fullWidth">
//         {devices.map(device => (
//           <Tab
//             key={device.id}
//             value={device.id}
//             label={
//               <Tooltip title={device.width} placement="top">
//                 <Box display="flex" alignItems="center" gap={1}>
//                   {/* <span>{device.icon}</span> */}
//                   <span>{device.label}</span>
//                 </Box>
//               </Tooltip>
//             }
//           />
//         ))}
//       </Tabs>
//     </Box>
//   );
// };

// export default DeviceTabs;

// import {Box, Tab, Tabs, Tooltip} from '@mui/material';

// const DeviceTabs = ({activeDevice, onDeviceChange, deviceTypes = ['mobile', 'tablet', 'desktop']}) => {
//   const devices = [
//     {id: 'mobile', label: '📱 Mobile', icon: '📱', width: '<768px'},
//     {id: 'tablet', label: '💻 Tablet', icon: '💻', width: '768px-1024px'},
//     {id: 'desktop', label: '🖥️ Desktop', icon: '🖥️', width: '>1024px'},
//   ];

//   const filteredDevices = devices.filter(device => deviceTypes.includes(device.id));

//   return (
//     <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
//       <Tabs
//         value={activeDevice}
//         onChange={(e, v) => onDeviceChange(v)}
//         variant="fullWidth">
//         {filteredDevices.map(device => (
//           <Tab
//             key={device.id}
//             value={device.id}
//             label={
//               <Tooltip title={device.width} placement="top">
//                 <Box display="flex" alignItems="center" gap={1}>
//                   <span>{device.label}</span>
//                 </Box>
//               </Tooltip>
//             }
//           />
//         ))}
//       </Tabs>
//     </Box>
//   );
// };

// export default DeviceTabs;
